var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"breadcrumb-demo"}},[_c('breadcrumb-default'),_c('breadcrumb-color'),_c('breadcrumb-separator'),_c('breadcrumb-slot'),_c('breadcrumb-alignment')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }